import { rage, useObservable } from '~/rage';
import {
	AppearanceOverlayConfig,
	Gender,
	IPedOverlayValue,
	PedOverlaySection,
} from '~/shared';
import {
	setOverlayConfigs,
	setOverlayValues,
	useLayoutDispatch,
} from '../redux';

const useResetOverlays = () => {
	const dispatch = useLayoutDispatch();
	const overlaySectionConfigs = useObservable(
		rage.characterCreation.getOverlaySectionConfigs(),
	);

	const processAppearanceSettings = (
		overlayConfigs: AppearanceOverlayConfig[],
	) => {
		return overlaySectionConfigs
			.map((config) => {
				const sectionOptions = overlayConfigs.filter(
					(option) => option.section === config.section,
				);

				if (sectionOptions.length === 0) return null;

				const minIndex = Math.min(...sectionOptions.map((opt) => opt.index));

				const setting: IPedOverlayValue = {
					section: config.section,
					index: minIndex,
				};

				if (config.withColor) {
					setting.colorPrimary = 0;
					setting.colorSecondary = 0;
				}

				if (config.withOpacity) {
					setting.colorOpacity = 1;
				}

				if (config.section === PedOverlaySection.Hair) {
					setting.index = 1;
				}

				return setting;
			})
			.filter((setting): setting is IPedOverlayValue => setting !== null);
	};

	const handleResetOverlays = async (gender: Gender) => {
		const overlayConfigs = rage.characterCreation
			.getOverlayConfigsByGender(gender)
			.getValue();

		const newOverlayValues = processAppearanceSettings(overlayConfigs);
		dispatch(setOverlayConfigs(overlayConfigs));
		dispatch(setOverlayValues(newOverlayValues));
		await rage.characterCreation.setOverlayValues(newOverlayValues);
	};

	return handleResetOverlays;
};

export { useResetOverlays };
